/**
 * useClip
 */

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';
import { useLang } from '../config';

const {
    useQuery,
} = ApolloLib;
const {
    GET_CLIP,
} = Queries;

const useClip = (ids, options = {}) => {

    const {
        ssr = true,
        skip = false,
        idType = 'SLUG',
        userId = '',
        withUser = (userId ? true : false),
    } = options;

    const lang = useLang();
    const {
        loading,
        error,
        data,
    } = useQuery(
        GET_CLIP,
        {
            variables: {
                ids,
                languagePreference: lang.toUpperCase(),
                idType,
                userId,
                withUser,
            },
            ssr,
            skip,
        }
    );

    return {
        loading,
        data,
        error,
    };

};

export default useClip;
